import { loadStripe } from '@stripe/stripe-js';

// Clave pública de Stripe — debe coincidir con la cuenta de STRIPE_SECRET_KEY (live con live, test con test)
const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

if (!STRIPE_PUBLIC_KEY) {
  console.error(
    'REACT_APP_STRIPE_PUBLIC_KEY no configurada. Añádela en client/.env antes del build de producción.'
  );
}

// Cargar Stripe
const stripePromise = STRIPE_PUBLIC_KEY ? loadStripe(STRIPE_PUBLIC_KEY) : null;

export default stripePromise; 